import { PJAX_MAIN_CONTAINER_SELECTOR } from './constants';
import { getMSFCaseStatus, validateMSFCaseStatus } from './consultations';
import { scrollToFirstFormInvalidElement } from './forms';

$(document).on('click', '.modal a[data-pjax]', function manageModalLink(event) {
  event.preventDefault();

  const url = $(this).attr('href');
  $(this).parents('.modal').modal('hide');
  // Wait for modal to be hidden, otherwise backdrop doesn't disappear.
  setTimeout(() => {
    $.pjax({ url, container: PJAX_MAIN_CONTAINER_SELECTOR });
  }, 300);
});

$(document).on('click', '#patient-anonymize-validate', function manageModalForm() {
  $(this).parents('.modal').modal('hide');

  const form = $(this).parent('form');
  // Wait for modal to be hidden, otherwise backdrop doesn't disappear.
  setTimeout(() => {
    form.trigger('submit');
  }, 300);
});

$(document).on('click', '#msf_case-close-validate', function manageModal() {
  $(this).parents('.modal').modal('hide');

  const form = document.getElementById($(this).attr('form'));
  // Wait for modal to be hidden, otherwise backdrop doesn't disappear.
  setTimeout(() => {
    if (validateMSFCaseStatus() && form.reportValidity()) {
      getMSFCaseStatus(form);
      $(form).trigger('submit');
    } else {
      scrollToFirstFormInvalidElement();
    }
  }, 300);
});

$(document).on('click', '.consultation-reminder-open', function openReminderModal(event) {
  event.preventDefault();

  const button = $(this).closest('tr').find('[data-reminder-url]');
  if (!button.length) {
    return;
  }

  $('#consultation-color_code').val(button.data('color-code')).trigger('change');
  $('#consultation-notes').val(button.data('notes'));
  $('#consultation-is_testing').prop('checked', button.data('is-testing'));
  const reminder = document.getElementById('consultation-reminder');
  reminder.dataset.newValue = button.data('reminder-at');
  reminder.dispatchEvent(new Event('initReminderInput'));
  $('#consultation-reminder-form').prop('action', button.data('reminder-url'));
  $('#consultation-reminder-modal').modal();
});

$(document).on('click', '#consultation-reminder-validate', function manageReminderModal() {
  const form = document.getElementById($(this).attr('form'));
  if (form.reportValidity()) {
    $(this).parents('.modal').modal('hide');
    // Wait for modal to be hidden, otherwise backdrop doesn't disappear.
    setTimeout(() => {
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
      })
        .finally(() => {
          $.pjax.reload(PJAX_MAIN_CONTAINER_SELECTOR);
        });
    }, 300);
  }
});

$(document).on('click', '.modals-delete-validate', function manageModalDelete() {
  $(this).parents('.modal').modal('hide');

  setTimeout(() => {
    fetch($(this).data('delete-url'), {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': $(this).data('csrf-token'),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        $.pjax({ url: data.url, container: PJAX_MAIN_CONTAINER_SELECTOR });
      });
  }, 300);
});
